var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.8563,
    height: 16.8566,
    rx: 8.42814,
    fill: "#CBF4C9",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51272 5.0596L8.8286 5.93682C9.17948 6.91041 9.94617 7.6771 10.9198 8.02799L11.797 8.34386C11.8761 8.37258 11.8761 8.48469 11.797 8.51301L10.9198 8.82889C9.94617 9.17978 9.17948 9.94646 8.8286 10.9201L8.51272 11.7973C8.484 11.8763 8.37189 11.8763 8.34357 11.7973L8.02769 10.9201C7.6768 9.94646 6.91012 9.17978 5.93652 8.82889L5.0593 8.51301C4.98023 8.4843 4.98023 8.37219 5.0593 8.34386L5.93652 8.02799C6.91012 7.6771 7.6768 6.91041 8.02769 5.93682L8.34357 5.0596C8.37189 4.98013 8.484 4.98013 8.51272 5.0596Z",
    fill: "#419364"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitterIcon);
export default __webpack_public_path__ + "static/media/GlitterIcon.5796ad56bf1e733b2e3b34238dc418dc.svg";
export { ForwardRef as ReactComponent };